var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"intercom"},[_c('Walkie',{attrs:{"soloPage":_vm.soloPage}}),_c('div',{attrs:{"id":"walkieDiv"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }